import { DoorProduct } from '~/config/doorProducts'
import { showAlert } from '~/store/alert'
import { useAppDispatch } from '~/store/hooks'
import { setActiveTool } from '~/store/tools'
import { MenuItem } from '~/ui/Menu'

export const DoorProductOption = (props: DoorProduct) => {
  const dispatch = useAppDispatch()
  const handleClick = () => {
    dispatch(setActiveTool({ tool: 'DOOR_PRODUCT_TOOL', props }))
    dispatch(showAlert({ text: 'Tap a door to place the product' }))
  }
  return (
    <MenuItem className="cursor-pointer flex items-center gap-2 p-2.5 text-xs" onAction={handleClick}>
      <div className="relative w-[30px] h-[30px] bg-white">
        <img
          className={`absolute w-[30px] h-[30px] inset-0 object-contain`}
          src={new URL(`/src/assets/thumbnails/${props.name}.jpg`, import.meta.url).href}
          alt={props.name}
        />
      </div>
      {props.name}
    </MenuItem>
  )
}
